'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clearRenderer = function clearRenderer() {
	return _react2.default.createElement('span', {
		className: 'Select-clear',
		dangerouslySetInnerHTML: { __html: '&times;' }
	});
};

exports.default = clearRenderer;


//////////////////
// WEBPACK FOOTER
// ./~/react-select/lib/utils/defaultClearRenderer.js
// module id = 975
// module chunks = 0